import { Vod } from './Vod'

export class Movie extends Vod {
    isMovie() {
        return true
    }
}
